import React, { useEffect, useState } from 'react';
import { ConfirmDeleteMessage } from '../../extras/toastMessages';
import { ACTION_EDIT, ACTION_DELETE } from '../../extras/actionTypes';
import TableList from '../../layout/TableList';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { listTurnsAction, editTurnsAction, deleteTurnsAction } from '../../../actions/turnsActions';
import { Spinner } from 'react-bootstrap';
import { MSG_DELETE, MSG_NOT_REVERT_OPERATION } from '../../../constants/messages';
import AuthoritiesService from '../../../services/AuthoritiesService';
import { PARAMETROS_ELIMINAR, PARAMETROS_MODIFICAR, TURNOS_ELIMINAR, TURNOS_MODIFICAR } from '../../../data/objects';
import QuickFilter from '../../layout/QuickFilter';
import Paginator from '../../layout/Paginator';
import TurnSearch from './TurnSearch';
//Función principal
const TurnList = props => {
    //Constantes iniciales
    const initialPage = 0;
    const pageSize = 10;
    //Tomo los props
    const { handleOpen, handleClose } = props;
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Traigo el store de persona tipos
    const authorities = useSelector(state => state.auth.authorities);
    const turnsLoading = useSelector( state => state.turns.loading );
    const turns = useSelector( state => state.turns.turns );
    const isLast = useSelector(state => state.turns.isLast);
    const isFirst = useSelector(state => state.turns.isFirst);
    const total = useSelector(state => state.turns.total);
    const totalPages = useSelector(state => state.turns.totalPages);
    const actualPage = useSelector(state => state.turns.actualPage);
    //Inicializo el state local
    const [ search, setSearch ] = useState('');
    //Parámetros iniciales
    const params = {
        paging: `${initialPage},${pageSize}`,
        sort: 'inicio:desc,fin:desc',
        search
    }
    //Manejo de la edición
    const handleEdit = item => {
        //Llamo al dispatch de edición
        dispatch( editTurnsAction(item, handleOpen) );
    }
    //Manjo la eliminación
    const handleDelete = item => {
        //Confirmación
        ConfirmDeleteMessage(
            MSG_DELETE,
            MSG_NOT_REVERT_OPERATION,
            () => {
                dispatch( deleteTurnsAction(item) )
            }
        )
    }
    //Inicializo las cabeceras
    const headers = [
        {
            name: 'Apellido',
            width: null,
            style: null,
            field: 'juez',
            subfield: 'apellido'
        },
        {
            name: 'Nombre',
            width: null,
            style: null,
            field: 'juez',
            subfield: 'nombre'
        },
        {
            name: 'F. Inicio',
            width: null,
            style: 'text-center',
            field: 'inicio',
            type: 'date'
        },
        {
            name: 'F. Fin',
            width: null,
            style: 'text-center',
            field: 'fin',
            type: 'date'
        },
        {
            name: 'Acción',
            width: '10%',
            style: 'text-center',
            actions: [
                {
                    name: ACTION_EDIT,
                    handle: handleEdit,
                    granted: authorities && AuthoritiesService.hasPermission(authorities, TURNOS_MODIFICAR)
                },
                {
                    name: ACTION_DELETE,
                    handle: handleDelete,
                    granted: authorities && AuthoritiesService.hasPermission(authorities, TURNOS_ELIMINAR)
                }
            ]
        }
    ];
    //Cargo los datos
    useEffect(() => {
        //Cargo los datos
        loadData(params);
    }, [search]);
    //Manejo la carga de datos
    const loadData = parameters => {
        //Llamo al dispatch
        dispatch( listTurnsAction(parameters) );
    }
    //Renderizo
    return (
        <div className="row">
            <div className="col-12">
                <div className="card shadow mb-4">
                    <div className="card-header py-3">
                    <h6 className="m-0 font-weight-bold text-primary">Listado</h6>
                    </div>
                    <div className="card-body">
                        <TurnSearch
                            setSearch={setSearch}
                        />

                        <hr/>

                        {
                            turnsLoading ? (
                                <Spinner animation="border" role="status">
                                    <span className="sr-only">Cargando...</span>
                                </Spinner>
                            ) : null
                        }
                        {
                            turns ? (
                                <React.Fragment>
                                    <TableList
                                        prefix="turn"
                                        headers={headers}
                                        items={turns}
                                        state={{
                                            field: 'activo',
                                            disabledClass: 'table-danger',
                                            disabledValue: 0,
                                            hideActions: true
                                        }}
                                    />
                                    <Paginator
                                        actualPage={actualPage}
                                        totalPages={totalPages}
                                        isFirst={isFirst}
                                        isLast={isLast}
                                        pageSize={pageSize}
                                        params={params}
                                        loadData={loadData}
                                    />
                                </React.Fragment>
                            ) : null
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TurnList;